module.exports = __webpack_public_path__ + "static/media/ch.615d3645.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/new/ch.png
// module id = 729
// module chunks = 0